import { apiClient } from '@app/api';
import { useStation } from '@app/core/stations/hooks/useStation';
import { downloadBlob } from '@mi-front/core';
import { Info } from '@mi-front/ui';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFragmentCtx } from '../../../context/fragment-ctx';
import { SubtitlesStatusView } from './SubtitleStatusView';

export const FormatDictionary = {
  txt: 'text/plain',
  srt: 'text/srt',
  // csv: 'text/csv;charset=utf-8;',
  json: 'application/json',
};

export const SubtitlesStatusContainer = () => {
  const fragment = useFragmentCtx();
  const station = useStation(fragment.stationId);
  const { slug } = station;
  const [format, setFormat] = useState<string>('txt');
  const [speakerIdCheck, setSpeakerIdCheck] = useState<boolean>(false);

  const onSpeakerIdChange = (value: boolean) => {
    setSpeakerIdCheck(value);
  };

  const { mutate, isPending } = useMutation({
    mutationFn: (format: string) =>
      apiClient.fragments
        .getTranscriptionDownload(slug, fragment.id ?? '', format, speakerIdCheck)
        .then((data) => {
          if (format === 'json') {
            downloadBlob(
              new Blob([JSON.stringify(data, null, '\t')], {
                type: FormatDictionary[format as keyof typeof FormatDictionary],
              }),
              `subtitles-${fragment.slug}.${format}`,
            );
          }
          // else if (format === 'csv') {
          //   downloadBlob(
          //     new Blob([data], {
          //       type: FormatDictionary[format as keyof typeof FormatDictionary],
          //     }),
          //     `subtitles-${fragment.slug}.${format}`,
          //   );
          // }
          else {
            downloadBlob(
              new Blob([data], {
                type: FormatDictionary[format as keyof typeof FormatDictionary],
              }),
              `subtitles-${fragment.slug}.${format}`,
            );
          }
        }),
  });

  const onDownloadClick = (format: string) => {
    setFormat(format);
    mutate(format);
  };

  return (
    <Info
      title={<FormattedMessage id="fragments.subtitlesStatus.title" defaultMessage="Subtítulos" />}
      data={
        <SubtitlesStatusView
          fragment={fragment}
          onDownloadClick={onDownloadClick}
          format={format}
          isPending={isPending}
          speakerIdCheck={speakerIdCheck}
          onSpeakerIdChange={onSpeakerIdChange}
        />
      }
    />
  );
};
